/**
 * @module events/types/dragOver
 */

/**
 * @type {string}
 */
export default 'dragover'
